/**
 * useIsMobile — tracks whether the viewport is below the `md:` (768px)
 * breakpoint. Used by the M2 layout shell (sidebar drawer, mobile top
 * bar) and by ResponsiveModal to pick between Vaul Drawer and Radix
 * Dialog.
 *
 * Locked breakpoints (CLAUDE.md M1/M2):
 *   mobile + tablet portrait  : < 768px  -> isMobile = true
 *   tablet landscape + desktop: >= 768px -> isMobile = false
 *
 * The matchMedia listener keeps state synchronized with viewport
 * resizes (devtools rotation, browser-window drag).
 */
import { useEffect, useState } from "react";

const MOBILE_QUERY = "(max-width: 767px)";

function readMatch() {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return false;
  }
  return window.matchMedia(MOBILE_QUERY).matches;
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(readMatch);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return undefined;
    }
    const mq = window.matchMedia(MOBILE_QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
